import moment from 'moment';

export const DATE_FORMAT = 'MMM DD, YYYY';

export const now = () => moment();

export const toMomentDate = (date?: string | Date) => moment(date);

export const formatDate = (date: Date | string, format: string) => toMomentDate(date).format(format);
